import Box from "ds/components/Box";
import { type TableCellContentProps } from "ds/components/Table/Row/CellContent";

import IacManagementTableCell from "../Cell";
import styles from "../styles.module.css";

const IacManagementTableRowServiceCell = ({ children, ...props }: TableCellContentProps) => {
  return (
    <IacManagementTableCell className={styles.serviceCell} {...props}>
      <Box padding="x-large" className={styles.serviceCellWrapper}>
        {children}
      </Box>
    </IacManagementTableCell>
  );
};

export default IacManagementTableRowServiceCell;
